import { render, staticRenderFns } from "./TournamentPage.vue?vue&type=template&id=2dae36e5&"
import script from "./TournamentPage.vue?vue&type=script&lang=ts&"
export * from "./TournamentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports